export const mobileMaxScreenWidth: number = 500;